<div class="d-flex justify-content-center align-items-center">
  <button
    (click)="selectPrevious()"
    [disabled]="disabled || value <= 0"
    class="btn btn-outline-primary d-flex justify-content-center align-items-center me-3"
    type="button"
  >
    <span>{{previousTitle}}</span>
  </button>
  <span>{{value + 1}}</span>
  <span class="mx-1">{{ofTitle}}</span>
  <span>{{lastPageIndex + 1}}</span>
  <span class="ms-1">{{pagesTitle}}</span>
  <button
    (click)="selectNext()"
    [disabled]="disabled || value >= lastPageIndex"
    class="btn btn-outline-primary d-flex justify-content-center align-items-center ms-3"
    type="button"
  >
    <span>{{nextTitle}}</span>
  </button>
</div>
